import * as pjson from '../../package.json';

export const packageName = pjson.name;
export const packageVersion = pjson.version;
export const gitRefName = process.env.REACT_APP_GIT_REF_NAME;
export const gitRefSha = process.env.REACT_APP_GIT_REF_SHA;
export const gitRefShaShort = (gitRefSha || '').substring(0, 8);
export const buildNumber = process.env.REACT_APP_BUILD_NUMBER;
export const fullBuildVersion = `${packageName}@${packageVersion}+${gitRefShaShort}-${buildNumber}`;
